import { SCROLL_TO_SELECTED_DATE_DELAY_MS } from '../../constants/delay';
import { scrollToDate, scrollToDateStart } from '../../helpers/scroll/scroll-to-date';
import usePlannerStore from '../index';

/**
 * Executes pendingScrollCommand: the animated DOM scroll a navigation action
 * requested for a target that is already rendered + loaded (cache hit). Keeps
 * the DOM/setTimeout side effects OUT of the store actions. The short delay
 * lets the store update render first so the target header cell exists.
 */
export const subscribeScrollCommands = (): (() => void) =>
  usePlannerStore.subscribe((state, prevState) => {
    const command = state.pendingScrollCommand;
    if (!command || command === prevState.pendingScrollCommand) return;

    setTimeout(() => {
      const scroll = command.align === 'start' ? scrollToDateStart : scrollToDate;
      scroll(command.target);
    }, SCROLL_TO_SELECTED_DATE_DELAY_MS);
  });
